export default "__VITE_ASSET__DlgiJ4kx__"